<template>
  <div class="room">
    <div class="room__bar-fill"></div>
    <div class="room__header">
      <div class="room__title">
        <h3 v-show="!isTitleEditable">
          {{ room.name }}
        </h3>
        <form @submit.prevent="submitRoomName">
          <input
            v-show="isTitleEditable"
            name="room-title"
            class="room__input"
            ref="titleInputRef"
            v-model="titleInput"
            @blur="endRoomEdit"
          />
        </form>
        <span
          >{{ room.shoppingListRoomProducts.length }}
          <!-- handle-room is handle class for vue-draggable -->
          <button class="handle-room drag-btn">
            <svg
              width="18"
              height="18"
              viewBox="0 0 18 18"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M2.58333 0.75H0.75V2.58333H2.58333V0.75ZM15.4167 4.41667H17.25V9.91667H15.4167V6.25H6.25V15.4167H9.91667V17.25H4.41667V4.41667H15.4167ZM4.41667 0.75H6.25V2.58333H4.41667V0.75ZM2.58333 4.41667H0.75V6.25H2.58333V4.41667ZM0.75 8.08333H2.58333V9.91667H0.75V8.08333ZM2.58333 11.75H0.75V13.5833H2.58333V11.75ZM8.08333 0.75H9.91667V2.58333H8.08333V0.75ZM13.5833 0.75H11.75V2.58333H13.5833V0.75ZM11.75 13.5833V11.75H17.25V13.5833H15.4167V15.4167H13.5833V17.25H11.75V13.5833ZM15.4167 15.4167V17.25H17.25V15.4167H15.4167Z"
                fill="#A8ACAF"
              />
            </svg>
          </button>
        </span>
      </div>
      <div
        class="room__action"
        v-if="projectInfo.myRoleInProject === Role.Architect"
      >
        <button
          class="room__action-button"
          :title="$t('list.room_delete')"
          @click="onEditRoomName"
        >
          <svg
            width="16"
            height="16"
            viewBox="0 0 13 12"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M1.31507 10.6849H2.23562L7.90685 5.0137L6.9863 4.09315L1.31507 9.76438V10.6849ZM10.7178 4.06027L7.92329 1.29863L8.84384 0.378082C9.09589 0.126027 9.40559 0 9.77293 0C10.1398 0 10.4493 0.126027 10.7014 0.378082L11.6219 1.29863C11.874 1.55068 12.0055 1.8549 12.0164 2.21129C12.0274 2.56723 11.9069 2.87123 11.6548 3.12329L10.7178 4.06027ZM9.76438 5.03014L2.79452 12H0V9.20548L6.96986 2.23562L9.76438 5.03014ZM7.44658 4.55342L6.9863 4.09315L7.90685 5.0137L7.44658 4.55342Z"
              fill="currentColor"
            />
          </svg>
        </button>
        <button
          class="room__action-button"
          :title="$t('list.room_delete')"
          @click="onDeleteRoom(room.id)"
        >
          <svg
            width="16"
            height="16"
            viewBox="0 0 16 17"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M14.875 2.75625H11.7437L11.7438 2.125L11.7437 2.12432C11.7415 1.62957 11.544 1.15571 11.1941 0.805865C10.8443 0.456017 10.3704 0.258485 9.87568 0.25625H9.875L6.125 0.256248L6.12432 0.256252C5.62957 0.258485 5.15571 0.456017 4.80586 0.805865C4.45602 1.15571 4.25849 1.62957 4.25625 2.12432V2.125V2.75625H1.125C0.960897 2.75625 0.803516 2.82144 0.687478 2.93748C0.571439 3.05352 0.50625 3.2109 0.50625 3.375C0.50625 3.5391 0.571439 3.69648 0.687478 3.81252C0.803516 3.92856 0.960897 3.99375 1.125 3.99375H1.75625V15.25C1.75625 15.5799 1.88729 15.8962 2.12054 16.1295C2.35378 16.3627 2.67014 16.4937 3 16.4937H13C13.3299 16.4937 13.6462 16.3627 13.8795 16.1295C14.1127 15.8962 14.2437 15.5799 14.2437 15.25V3.99375H14.875C15.0391 3.99375 15.1965 3.92856 15.3125 3.81252L15.2065 3.70646L15.3125 3.81252C15.4286 3.69648 15.4937 3.5391 15.4937 3.375C15.4937 3.2109 15.4286 3.05352 15.3125 2.93748L15.2065 3.04354L15.3125 2.93748C15.1965 2.82144 15.0391 2.75625 14.875 2.75625ZM5.49375 2.125C5.49375 1.95758 5.56026 1.79702 5.67864 1.67864C5.79702 1.56026 5.95758 1.49375 6.125 1.49375H9.875C10.0424 1.49375 10.203 1.56026 10.3214 1.67864L10.4274 1.57257L10.3214 1.67864C10.4397 1.79702 10.5063 1.95758 10.5063 2.125V2.75625H5.49375V2.125ZM13.0063 15.25C13.0063 15.251 13.006 15.252 13.0055 15.2529C13.0052 15.2535 13.0049 15.254 13.0044 15.2544L13.1105 15.3605L13.0044 15.2544C13.0032 15.2556 13.0017 15.2563 13 15.2563H3C2.99834 15.2563 2.99675 15.2556 2.99558 15.2544L2.88951 15.3605L2.99558 15.2544C2.99441 15.2532 2.99375 15.2517 2.99375 15.25V3.99375H13.0063V15.25ZM6.74375 12.125V7.125C6.74375 6.9609 6.67856 6.80352 6.56252 6.68748C6.44648 6.57144 6.2891 6.50625 6.125 6.50625C5.9609 6.50625 5.80352 6.57144 5.68748 6.68748C5.57144 6.80352 5.50625 6.9609 5.50625 7.125V12.125C5.50625 12.2891 5.57144 12.4465 5.68748 12.5625C5.80352 12.6786 5.9609 12.7437 6.125 12.7437C6.2891 12.7437 6.44648 12.6786 6.56252 12.5625C6.67856 12.4465 6.74375 12.2891 6.74375 12.125ZM10.4937 12.125V7.125C10.4937 6.9609 10.4286 6.80352 10.3125 6.68748C10.1965 6.57144 10.0391 6.50625 9.875 6.50625C9.7109 6.50625 9.55352 6.57144 9.43748 6.68748C9.32144 6.80352 9.25625 6.9609 9.25625 7.125V12.125C9.25625 12.2891 9.32144 12.4465 9.43748 12.5625C9.55352 12.6786 9.7109 12.7437 9.875 12.7437C10.0391 12.7437 10.1965 12.6786 10.3125 12.5625C10.4286 12.4465 10.4937 12.2891 10.4937 12.125Z"
              fill="currentColor"
              stroke="currentColor"
              stroke-width="0.3"
            />
          </svg>
        </button>
      </div>
    </div>
    <div class="room__bar"></div>
    <div>
      <!-- .handle is class name to use for element that should act as anchor for drag -->
      <draggable
        v-model="room.shoppingListRoomProducts"
        :group="shoppingListId"
        item-key="id"
        handle=".handle"
        @change="
          (event) =>
            onProductsOrderChange(event, {
              shoppingListId: shoppingListId,
              roomId: room.id,
            })
        "
      >
        <template #item="{ element: furn }">
          <ShoppingListProductItem
            :project-info="projectInfo"
            :project-id="projectId"
            :shopping-list-id="shoppingListId"
            :room-id="room.id"
            :furn="furn"
            @on-delete-product="
              onDeleteProduct({
                roomId: room.id,
                productId: furn.id,
              })
            "
            @on-copy-product="onCopyProduct"
          />
        </template>
      </draggable>
      <ShoppingListProductForm
        ref="productFormRef"
        v-if="projectInfo.myRoleInProject === Role.Architect"
        :project-id="projectId"
        :shopping-list-id="shoppingListId"
        :room-id="room.id"
      />
    </div>
  </div>
</template>

<script setup>
import draggable from "vuedraggable";

import { useShoppingListStore } from "@/stores/shoppingList.store";
import ShoppingListProductForm from "./ShoppingListProductForm.vue";
import { ref } from "vue";
import ShoppingListProductItem from "./ShoppingListProductItem.vue";
import { useAuthStore } from "@/stores/auth.store";
import { Role } from "@/helpsers/role.helper";

const props = defineProps({
  room: {
    type: Object,
  },
  projectId: {},
  projectInfo: {},
  shoppingListId: {},
});
const emit = defineEmits(["onDeleteProduct", "onDeleteRoom"]);

const auth = useAuthStore();

const store = useShoppingListStore();
function onProductsOrderChange(event, { shoppingListId, roomId }) {
  if (event.hasOwnProperty("moved")) {
    store.changeOrderOfProducts({ shoppingListId, roomId });
  } else if (event.hasOwnProperty("added")) {
    const productId = event.added.element.id;
    const oldRoomId = event.added.element.shoppingListRoomId;
    store.moveProductToRoom({
      shoppingListId,
      oldRoomId: oldRoomId,
      productId,
      newRoomId: roomId,
    });
  }
}

function onDeleteProduct({ roomId, productId }) {
  emit("onDeleteProduct", {
    shoppingListId: props.shoppingListId,
    roomId: roomId,
    productId: productId,
  });
}
function onDeleteRoom(roomId) {
  emit("onDeleteRoom", {
    shoppingListId: props.shoppingListId,
    roomId: roomId,
  });
}
const productFormRef = ref("");
function onCopyProduct(data) {
  productFormRef.value?.addPredefinedProduct(data);
}

const titleInputRef = ref(null);
const titleInput = ref("");
const isTitleEditable = ref(false);
function endRoomEdit() {
  isTitleEditable.value = false;
  titleInput.value = "";
}
async function submitRoomName() {
  const { isSuccess } = await store.editRoomName({
    shoppingListId: props.shoppingListId,
    roomId: props.room.id,
    name: titleInput.value,
  });
  if (isSuccess) {
    isTitleEditable.value = false;
    titleInput.value = "";
  }
}
function onEditRoomName() {
  isTitleEditable.value = true;
  titleInput.value = props.room.name;
  setTimeout(() => {
    titleInputRef.value?.focus();
  }, 0);
}
</script>

<style scoped lang="scss">
@use "@/css/shopping-list.scss";
@use "@/css/shopping-list-room.scss";
</style>
